import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { ManageCardsPage } from '@/components/manage-cards/ManageCardsPage'

export const Route = createFileRoute('/_protected/_site/manage-cards')({
  component: RouteComponent,
})

function RouteComponent() {
  const routeApi = getRouteApi("/_protected/_site")
  const data = routeApi.useLoaderData()

  const cards = data.config?.pages[0].cards?.filter(card => card.type !== 'footer1')

  if (!cards || cards.length === 0) {
    return <div>No cards found</div>
  }

  return <ManageCardsPage cards={cards} site={data} />
}
